import { forwardRef } from 'react'

import { Container } from 'components/container'
import { PersonType } from 'models'
import { useDataContext } from 'context/data-context'
import { PeopleList } from './people-list'
import { Section, Title } from './styled'

type Props = {
  person?: PersonType
  title?: string
}

export const VictimsList = forwardRef<HTMLDivElement, Props>(
  ({ person, title }, ref) => {
    const { people, translate } = useDataContext()

    return (
      <Section ref={ref}>
        <Container>
          <Title>{translate('List title')}</Title>
          <PeopleList people={people} />
        </Container>
      </Section>
    )
  }
)
